import axios from 'axios'
import querystring from 'querystring-es3'
import { Message } from 'element-ui'

import { BASE_URL } from './const'
import router from '@/router'

// 添加请求头
const instance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000, // 请求超时时间
})

// 通过拦截器格式化参数
instance.interceptors.request.use(
  config => {
    if (config.method !== 'get' && config.method !== 'delete' && !config.usePayload) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      config.data = querystring.stringify(config.data)
    }
    return config
  },
  error => Promise.reject(error)
)

export default (url = '', data = {}, type = 'POST', options = {}) => {
  return new Promise((resolve, reject) => {
    let httpPromise = null
    if (type.toUpperCase() === 'GET') {
      httpPromise = instance({
        method: type,
        url: url,
        params: data,
        ...options,
      })
    } else {
      httpPromise = instance({
        method: type,
        url: url,
        data: data,
        ...options,
      })
    }
    httpPromise
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        const status = err.response?.status
        const data = err.response?.data || {}

        if (status === 401 || data.c === 401) {
          Message.error('请先登录')
          reject(err.response?.data)
          router.replace('/login').catch(() => {})
          return
        }

        if (err.code === 'ECONNABORTED') {
          Message.error('请求超时')
          reject(new Error('请求超时'))
        } else if (data.c) {
          reject(data)
        } else {
          reject(new Error('请求失败'))
        }
      })
  })
}
